import { forwardRef, useId } from 'react';
import './Input.css';

const Input = forwardRef(function Input(
  { label, error, helperText, iconLeft, iconRight, className = '', id, ...rest },
  ref
) {
  const autoId = useId();
  const inputId = id || autoId;
  const describedBy = error ? `${inputId}-error` : helperText ? `${inputId}-helper` : undefined;

  return (
    <div className={`ds-field ${className}`.trim()}>
      {label && (
        <label htmlFor={inputId} className="ds-field-label">
          {label}
        </label>
      )}
      <div className={`ds-input-wrap ${error ? 'ds-input-wrap-error' : ''}`}>
        {iconLeft && <span className="ds-input-icon ds-input-icon-left">{iconLeft}</span>}
        <input
          ref={ref}
          id={inputId}
          className={`ds-input ${iconLeft ? 'ds-input-has-icon-left' : ''} ${iconRight ? 'ds-input-has-icon-right' : ''}`}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy}
          {...rest}
        />
        {iconRight && <span className="ds-input-icon ds-input-icon-right">{iconRight}</span>}
      </div>
      {error && (
        <span id={`${inputId}-error`} className="ds-field-error" role="alert">
          {error}
        </span>
      )}
      {!error && helperText && (
        <span id={`${inputId}-helper`} className="ds-field-helper">
          {helperText}
        </span>
      )}
    </div>
  );
});

export default Input;
